<template>
  <BaseOption>
    <template v-slot:body>
      <!-- General Statistic -->
      <div class="main-card mb-3 card order-options">
        <div class="card-header">
          Layout / General Statistic
          <div class="btn-actions-pane-right">
            <button type="submit" class="btn btn-primary" @click.stop.prevent="handleClickSave">Save</button>
          </div>
        </div>
        <div class="card-body">
          <LayoutConfig :config="{ data: values?.layouts?.['general-statistic'] || [], components }" @changeValue="changeLayoutValue('general-statistic', $event)" />
        </div>
      </div>

      <!-- Next Time -->
      <div class="main-card mb-3 card order-options">
        <div class="card-header">
          Next Time
          <div class="btn-actions-pane-right">
            <button type="submit" class="btn btn-primary" @click.stop.prevent="handleClickSave">Save</button>
          </div>
        </div>
        <div class="card-body">
          <NextTime :config="{ schedules: data?.schedules, values: Object.assign({}, values?.schedules) }" @changeValue="changeOrderScheduleValue" />
        </div>
      </div>

      <!-- Order -->
      <div class="main-card mb-3 card order-options">
        <div class="card-header">
          Order
          <div class="btn-actions-pane-right">
            <button type="submit" class="btn btn-primary" @click.stop.prevent="handleClickSave">Save</button>
          </div>
        </div>
        <div class="card-body row">
          <div class="position-relative form-group col-12">
            <label class="col-12 mb-0 p-0"><strong>Action</strong> › Use raw attributes</label>
            <div class="col-12 btn-group-sm nav btn-group mt-2 d-inline-block">
              <div v-for="(object, index) in data.use_raw_attributes" :key="index" class="radio-container btn-shadow btn btn-primary show p-0">
                <input type="radio" name="order[use_raw_attributes]" :value="index" :checked="values.use_raw_attributes == index" @change="store.commit('values.use_raw_attributes', $event.target.value)" />
                <span href="#" class="checkmark d-inline-block p-2">{{ object.label }}</span>
              </div>
            </div>
            <small>Required delivery file when import trackings</small>
          </div>
          <div class="position-relative form-group col-12">
            <label class="col-12 mb-0 p-0"><strong>Action</strong> › Required delivery file</label>
            <div class="col-12 btn-group-sm nav btn-group mt-2 d-inline-block">
              <div v-for="(object, index) in data.required_delivery_file" :key="index" class="radio-container btn-shadow btn btn-primary show p-0">
                <input type="radio" name="order[required_delivery_file]" :value="index" :checked="values.required_delivery_file == index" @change="store.commit('values.required_delivery_file', $event.target.value)" />
                <span href="#" class="checkmark d-inline-block p-2">{{ object.label }}</span>
              </div>
            </div>
            <small>Required delivery file when import trackings</small>
          </div>
          <div class="position-relative form-group col-12">
            <label class="col-12 mb-0 p-0"><strong>Action</strong> › Print Method</label>
            <div class="col-12 btn-group-sm nav btn-group mt-2 d-inline-block">
              <div v-for="(object, index) in data.print_method" :key="index" class="radio-container btn-shadow btn btn-primary show p-0">
                <input type="radio" name="order[print_method]" :value="index" :checked="values.print_method == index" @change="store.commit('values.print_method', $event.target.value)" />
                <span href="#" class="checkmark d-inline-block p-2">{{ object.label }}</span>
              </div>
            </div>
            <small>Require print method when updating line item</small>
          </div>
          <div class="position-relative form-group col-12 detail-open-blueprint">
            <label class="col-12 p-0"><strong>Action</strong> › Print Style</label>
            <Select :options="data.print_styles" placeholder="Print Style" data-title="Print Style" class="has-tip col-4 p-0" :value="values.print_style" @changeValue="store.commit('values.print_style', $event)"></Select>
            <small>Choose print style and size</small>
          </div>
          <div class="position-relative form-group col-12 detail-open-blueprint">
            <label class="col-12 mb-0 p-0"><strong>Action</strong> › Use Package</label>
            <div class="col-12 btn-group-sm nav btn-group mt-2 d-inline-block">
              <div v-for="(object, index) in data.use_package" :key="index" class="radio-container btn-shadow btn btn-primary show p-0">
                <input type="radio" name="order[use_package]" :value="index" :checked="values.use_package == index" @change="store.commit('values.use_package', $event.target.value)" />
                <span href="#" class="checkmark d-inline-block p-2">{{ object.label }}</span>
              </div>
            </div>
            <small>Set the default to manually add package sizes</small>
          </div>
          <div class="position-relative form-group col-12">
            <label class="col-12 mb-0 p-0"><strong>Action</strong> › Can add tracking when</label>
            <ul class="list-platform select-list">
              <li class="checkbox-container">
                <input type="radio" name="order[add_tracking]" value="blueprint" @change="handleChangeTracking" :checked="values.add_tracking == 'blueprint'" />
                <span class="checkmark user">Have blueprint</span>
              </li>
              <li class="checkbox-container">
                <input type="radio" name="order[add_tracking]" value="design" @change="handleChangeTracking" :checked="values.add_tracking == 'design'" />
                <span class="checkmark user">Have design</span>
              </li>
              <li class="checkbox-container">
                <input type="radio" name="order[add_tracking]" value="allow" @change="handleChangeTracking" :checked="values.add_tracking == 'allow'" />
                <span class="checkmark user">Always allow</span>
              </li>
            </ul>
          </div>
          <div class="position-relative form-group col-12">
            <label class="col-12 mb-0 p-0"><strong>Filter</strong> › Flags</label>
            <ul class="flags">
              <li v-for="(object, index) in data.flags" :key="index" class="radio-container">
                <input type="checkbox" name="order[flags]" :value="index" :checked="values?.flags && values?.flags.indexOf(index) != -1" @change="handleChangeFlag" />
                <span :class="`checkmark choose-flag ${index}`"></span>
              </li>
            </ul>
          </div>
          <div class="position-relative form-group col-6">
            <label class="col-12 p-0"><strong>Queue</strong> › Tracking offset</label>
            <div class="input-group form-group">
              <div class="input-group-prepend"><span class="input-group-text">Tracking Offset(h)</span></div>
              <input name="tracking_offset" type="number" :value="values.tracking_offset" @change="store.commit('values.tracking_offset', $event.target.value || 0)" class="form-control flex-1" />
            </div>
            <small>Enter a number &gt; 0 to delay the tracking by x hours from the time it was added. Enter a number &lt; 0 to move the tracking x hours earlier than the deadline.</small>
          </div>
          <div class="position-relative form-group col-12 detail-open-blueprint">
            <label class="col-12 mb-0 p-0"><strong>Process</strong> › Verified Order</label>
            <div class="col-12 btn-group-sm nav btn-group mt-2 d-inline-block">
              <div v-for="(object, index) in data.verified" :key="index" class="radio-container btn-shadow btn btn-primary show p-0">
                <input type="radio" name="order[verified]" :value="index" :checked="values.verified == index" @change="store.commit('values.verified', $event.target.value)" />
                <span href="#" class="checkmark d-inline-block p-2">{{ object.label }}</span>
              </div>
            </div>
            <small>Create a new design when editing a raw line item</small>
          </div>
        </div>
      </div>

      <!-- Printer & Color -->
      <div class="main-card mb-3 card order-options">
        <div class="card-header">
          Printer & Color
          <div class="btn-actions-pane-right">
            <button type="submit" class="btn btn-primary" @click.stop.prevent="handleClickSave">Save</button>
          </div>
        </div>
        <div class="card-body row">
          <div class="position-relative form-group col-12">
            <label class="col-12 mb-0 p-0">
              <strong>Printer Methods</strong>
              <button type="button" class="btn btn-outline-success ml-3" @click="store.commit('values.print_methods', (values.print_methods || []).concat(''))">Add</button>
            </label>
            <div class="list-group mt-3">
              <div v-for="(method, index) in values.print_methods" :key="index" class="d-flex align-items-center mt-2">
                <input type="text" class="form-control flex-1" placeholder="Enter printer method" :value="method" @change="store.commit(`values.print_methods.${index}`, $event.target.value)" />
                <button type="button" class="btn btn-danger ml-2" @click="handleRemovePrintMethod(index)">Remove</button>
              </div>
            </div>
            <small>Add printer methods for order management</small>
          </div>

          <div class="position-relative form-group col-12">
            <label class="col-12 mb-0 p-0">
              <strong>Color Batches</strong>
              <button type="button" class="btn btn-outline-success ml-3" @click="store.commit('values.color_batches', (values.color_batches || []).concat({ color: '', name: '' }))">Add</button>
            </label>
            <div class="list-group mt-3">
              <div v-for="(batch, index) in values.color_batches" :key="index" class="d-flex align-items-center mt-2">
                <input type="text" class="form-control flex-1 mr-2" placeholder="Enter color code" :value="batch.color" @change="store.commit(`values.color_batches.${index}.color`, $event.target.value)" />
                <input type="text" class="form-control flex-1 ml-2" placeholder="Enter color name" :value="batch.name" @change="store.commit(`values.color_batches.${index}.name`, $event.target.value)" />
                <button type="button" class="btn btn-danger ml-2" @click="handleRemoveColorBatch(index)">Remove</button>
              </div>
            </div>
            <small>Add color batches for order management</small>
          </div>
        </div>
      </div>

      <!-- Line Item -->
      <div class="main-card mb-3 card order-options">
        <div class="card-header">
          Line Item
          <div class="btn-actions-pane-right">
            <button type="submit" class="btn btn-primary" @click.stop.prevent="handleClickSave">Save</button>
          </div>
        </div>
        <div class="card-body row">
          <div class="position-relative form-group col-12 detail-open-blueprint">
            <label class="col-12 mb-0 p-0">New Design</label>
            <div class="col-12 btn-group-sm nav btn-group mt-2 d-inline-block">
              <div v-for="(object, index) in data.new_design" :key="index" class="radio-container btn-shadow btn btn-primary show p-0">
                <input type="radio" name="order[line_item][detail][new_design]" :value="index" :checked="lineItemValues?.detail?.new_design == index" @change="store.commit('values.line_item.detail.new_design', $event.target.value)" />
                <span href="#" class="checkmark d-inline-block p-2">{{ object.label }}</span>
              </div>
            </div>
            <small>Create a new design when editing a raw line item</small>
          </div>
          <div class="position-relative form-group col-12 d-flex flex-wrap">
            <label class="col-12 mb-0 p-0">Suggest design name</label>
            <div class="col-6 pl-0 pr-1 mt-2">
              <input class="form-control has-tip" data-title="No Flag" placeholder="No Flag" type="text" :value="lineItemValues?.detail?.design_suggest?.no_flag" @change.stop.prevent="store.commit('values.line_item.detail.design_suggest.no_flag', $event.target.value)" />
            </div>
            <div class="col-6 pr-0 pl-1 mt-2">
              <input class="form-control has-tip" data-title="Has Flag" placeholder="Has Flag" type="text" :value="lineItemValues?.detail?.design_suggest?.has_flag" @change.stop.prevent="store.commit('values.line_item.detail.design_suggest.has_flag', $event.target.value)" />
            </div>
            <small class="mt-1 font-italic text-muted">Allow &#123;&#123;&#37; buyer_name &#37;&#125;&#125;, &#123;&#123;&#37; order_id &#37;&#125;&#125;, &#123;&#123;&#37; product_id &#37;&#125;&#125;, &#123;&#123;&#37; product_sku &#37;&#125;&#125;, &#123;&#123;&#37; [attribute name] &#37;&#125;&#125;</small>
          </div>
        </div>
      </div>
    </template>
  </BaseOption>
</template>

<script>
import Event from '@/helper/event.js'
import BaseOption from '@/views/Option/BaseOption.vue'
import NextTime from '@/views/Option/NextTime.vue'
import LayoutConfig from '@/components/LayoutConfig.vue'

export default {
  mixins: [Event],
  components: {
    BaseOption,
    NextTime,
    LayoutConfig
  },

  computed: {
    storeId() {
      return 'main'
    },
    indexUri() {
      return 'order/option'
    },
    submitUri() {
      return 'order/option/update'
    },
    data() {
      return this.store.getter('data', {
        layouts: {
          'general-statistic': []
        },
        flags: {},
        print_styles: []
      })
    },
    components() {
      let components = this.$util.requiresOrNull('/Order/Option/Modal/.*')
      let results = {}
      Object.entries(components).forEach(([key, component]) => {
        let keys = key.split('/Modal/')
        results[`${keys[1].replace('.vue', '')}`] = {
          component: `${keys[0].replace('/Views/', '')}.${keys[1].replace('.vue', '')}`,
          label: component.name || component?.computed?.title() || 'Component',
          description: component.description || '',
          grid: component.grid || []
        }
      })
      return results
    },
    values() {
      return this.store.getter('values', {})
    },
    lineItemValues() {
      return Object.assign(
        {
          detail: {
            new_design: 0
          }
        },
        this.values.line_item
      )
    },
    colorBatches() {
      return (
        this.values.color_batches || [
          {
            color: '',
            name: ''
          }
        ]
      )
    }
  },
  methods: {
    setUpData({ status, data }) {
      if (status != 'success') return
      data.values = Object.assign(
        {
          required_delivery_file: 1,
          print_method: 0,
          flags: ['empty', 'yellow', 'orange', 'red', 'green', 'blue'],
          print_style: '5x3',
          print_methods: [],
          color_batches: [],
          use_package: 0,
          add_tracking: 'blueprint',
          tracking_offset: 0,
          verified: 0,
          line_item: {
            detail: {
              new_design: 1,
              design_suggest: {
                no_flag: '{{% order_id %}}',
                has_flag: '{{% order_id %}} - {{% product_id %}}'
              }
            }
          },
          layouts: {
            'general-statistic': [
              {
                x: 0,
                y: 0,
                w: 12,
                h: 1,
                widget: {
                  component: 'Summary',
                  data: []
                }
              },
              {
                x: 0,
                y: 1,
                w: 4,
                h: 1,
                widget: {
                  component: 'TotalSale',
                  data: []
                }
              },
              {
                x: 4,
                y: 1,
                w: 4,
                h: 1,
                widget: {
                  component: 'TopSeller',
                  data: []
                }
              },
              {
                x: 8,
                y: 1,
                w: 4,
                h: 1,
                widget: {
                  component: 'TotalStatuses',
                  data: []
                }
              },
              {
                x: 0,
                y: 2,
                w: 6,
                h: 1,
                widget: {
                  component: 'OrderQuantity',
                  data: []
                }
              },
              {
                x: 6,
                y: 2,
                w: 6,
                h: 1,
                widget: {
                  component: 'TopSellingProduct',
                  data: []
                }
              },
              {
                x: 0,
                y: 3,
                w: 6,
                h: 1,
                widget: {
                  component: 'DesignQuantity',
                  data: []
                }
              },
              {
                x: 6,
                y: 3,
                w: 6,
                h: 1,
                widget: {
                  component: 'DesignIdeaQuantity',
                  data: []
                }
              }
            ]
          }
        },
        data.values
      )
      this.store.commit('', data)
    },
    changeOrderScheduleValue(e) {
      this.store.commit('values.schedules', e)
    },
    changeLayoutValue(name, e) {
      this.store.commit(`values.layouts.${name}`, e)
    },
    handleChangeFlag(e) {
      let values = Object.values(this.values.flags || [])
      if (e.target.checked == true) {
        values.push(e.target.value)
      } else if (values.indexOf(e.target.value) !== -1) {
        values.splice(values.indexOf(e.target.value), 1)
      }
      this.store.commit('values.flags', values)
    },
    handleChangeTracking(e) {
      this.store.commit('values.add_tracking', e.target.value)
    },
    handleRemovePrintMethod(index) {
      const methods = [...this.values.print_methods]
      methods.splice(index, 1)
      this.store.commit('values.print_methods', methods)
    },
    handleRemoveColorBatch(index) {
      const batches = [...this.colorBatches]
      batches.splice(index, 1)
      this.store.commit('values.color_batches', batches)
    },
    handleClickSave() {
      this.submitForm(this.store.getter('values', {}))
    }
  }
}
</script>
